export default "__VITE_ASSET__DgtzpZzc__"